// extracted by mini-css-extract-plugin
export default {"vertical-line":"VerticalLine_vertical-line__1SPq2","vertical-line__text":"VerticalLine_vertical-line__text__p18Mr"};